import { Box, Card, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FC, useCallback } from 'react';
import { ImageField, useInput } from 'react-admin';
import 'react-tabs/style/react-tabs.css';
import _debounce from 'lodash/debounce';
import ReactMarkdown from 'react-markdown';
// import RichTextInput from 'ra-input-rich-text';
import SimpleMDE from 'react-simplemde-editor';
import 'easymde/dist/easymde.min.css';
// import SimpleMdeReact from 'react-simplemde-editor/dist/SimpleMdeReact';
// import 'easymde/dist/easymde.min.css';
// import * as MarkdownEditor from '@uiw/react-markdown-editor';
import '../index.css';
import TitleText from '../../common/title-text';
import SubtitleText from '../../common/subtitle-text';

interface Props {
  isBlocked: boolean;
  changeStatus: () => void;
  isShow: boolean;
}

interface SelectCountries {
  id: string;
  name: string;
}
let statuses = ['draft', 'publish', 'personal'];

const BlogMarkdownEditor = (props) => {
  const {
    input: { name, onChange, value },
    meta: { touched, error },
    isRequired,
  } = useInput(props);

  // const [valueText, setValue] = useState('');

  function handleDebounceFn(inputValue) {
    onChange(inputValue);
  }

  const debounceFn = useCallback(_debounce(handleDebounceFn, 500), []);

  function handleChange(value) {
    // setValue(value);
    debounceFn(value);
  }

  return (
    <React.Fragment>
      {!props.isShow ? (
        <Box
          display={'flex'}
          flexDirection={'column'}
          height={'600px'}
          overflow={'auto'}
        >
          <SimpleMDE
            value={value}
            onChange={handleChange}
            // onChange={(value) => {
            //   onChange(value);
            // }}
            options={{
              sideBySideFullscreen: false,
              autofocus: true,
              spellChecker: false,
              // etc.
            }}
          />
        </Box>
      ) : null}
      <Box>
        <Typography gutterBottom className='base-color'>
          PREVIEW
        </Typography>
        <div className='post'>
          <div className='container'>
            <div className='post__head'>
              <div className='post__info'>
                <TitleText
                  as='h1'
                  color='color-5'
                  variant={undefined}
                  isCentered={undefined}
                >
                  {props.record?.title || ''}
                </TitleText>
                <SubtitleText
                  color='color-5'
                  className='post__description'
                  isCentered={undefined}
                  as={undefined}
                >
                  {props.record?.shortDescription || ''}
                </SubtitleText>
              </div>
              <div className='post__img'>
                <ImageField source='filesPreviewImage' title='title' />
              </div>
            </div>
            <ReactMarkdown
              children={value}
              className='post__content'
              components={{
                h1: (props) => <TitleText {...props} as='h1' color='color-5' />,
                h2: (props) => <TitleText {...props} as='h2' color='color-5' />,
                h3: (props) => <TitleText {...props} as='h3' color='color-5' />,
                h4: (props) => <TitleText {...props} as='h4' color='color-5' />,
                h5: (props) => <TitleText {...props} as='h5' color='color-5' />,
                h6: (props) => <TitleText {...props} as='h6' color='color-5' />,
                p: (props) => <SubtitleText {...props} color='color-5' />,
                li: (props) => (
                  <SubtitleText {...props} as='li' color='color-5' />
                ),
                img: (props) => (
                  <figure>
                    <img {...props} alt={props.alt} />
                  </figure>
                ),
              }}
            />
          </div>
        </div>
      </Box>
    </React.Fragment>
  );
};

export default BlogMarkdownEditor;
